/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_ButtonInputs */

const en_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const fr_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer`)
};

const de_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const it_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importare`)
};

const ru_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт`)
};

const es_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

const zh_cn2_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口`)
};

const ja_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入`)
};

const hi_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात`)
};

const pt_pt2_preset_manager_import_button = /** @type {(inputs: Preset_Manager_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {Preset_Manager_Import_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_button = /** @type {((inputs?: Preset_Manager_Import_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_button(inputs)
	if (locale === "de") return de_preset_manager_import_button(inputs)
	if (locale === "it") return it_preset_manager_import_button(inputs)
	if (locale === "ru") return ru_preset_manager_import_button(inputs)
	if (locale === "es") return es_preset_manager_import_button(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_button(inputs)
	if (locale === "ja") return ja_preset_manager_import_button(inputs)
	if (locale === "hi") return hi_preset_manager_import_button(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_button(inputs)
	return en_preset_manager_import_button(inputs)
});